import {
  SET_CONFIRM_MODAL_ID,
  SET_CONFIRM_MODAL_IS_VISIBLE,
  SET_CONFIRM_MODAL_TITLE,
  SET_CONFIRM_MODAL_MESSAGE,
  SET_CONFIRM_MODAL_CALLBACK
} from './types'

export const state = {
  isVisible: false,
  title: '',
  message: '',
  callback: null
}

export const mutations = {
  [SET_CONFIRM_MODAL_ID] (state, value) {
    state.id = value
  },
  [SET_CONFIRM_MODAL_IS_VISIBLE] (state, value) {
    state.isVisible = value
  },
  [SET_CONFIRM_MODAL_TITLE] (state, value) {
    state.title = value
  },
  [SET_CONFIRM_MODAL_MESSAGE] (state, value) {
    state.message = value
  },
  [SET_CONFIRM_MODAL_CALLBACK] (state, value) {
    state.callback = value
  }
}

export const actions = {
  openConfirmModal ({ commit, dispatch }, { title, message, callback }) {
    commit(SET_CONFIRM_MODAL_TITLE, title)
    commit(SET_CONFIRM_MODAL_MESSAGE, message)
    commit(SET_CONFIRM_MODAL_CALLBACK, callback)
    commit(SET_CONFIRM_MODAL_IS_VISIBLE, true)
  },
  closeConfirmModal ({ commit }) {
    commit(SET_CONFIRM_MODAL_IS_VISIBLE, false)
  },
  execConfirmCallback ({ state }) {
    state.callback()
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/common/confirmModal.js